export default "__VITE_ASSET__Dk8IcuGb__"